module.exports = __webpack_public_path__ + "fonts/Graphik-Black.dd64d12a.woff";